import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../shared/services/user.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;
  userDetails;
  constructor(private router : Router, public service :UserService){}


  ngOnInit(){
    this.service.getUserProfile().subscribe(
      res=>
      {
          this.userDetails = res;
      },
      err=>{
        console.log(err);
        this.onLogout();
      });
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  onLogout(){
    localStorage.removeItem("token");
    this.router.navigate(["/login"]);
  }
}
export class userDetails
{
  fullName: string;
  email: string;
  userName: string;
}
